// 自定义顶部导航栏菜单栏的问题
class NavMenu {
  constructor(options) {
    this.navBox = document.querySelector(options)
    this.boxList = this.navBox.querySelectorAll('li.menu-lv-1')
    this.init()
  }
  init () {
    if (!this.boxList.length) return
    this.boxList.forEach((i) => {
      const box = i.querySelector('.dropdown-menu-mobile.text-left.style_linklists')
      if (!box) return
      i.addEventListener('mouseover', () => {
        box.style.top = 40 + 'px'
      })
    })
  }
}
